module.exports = __webpack_public_path__ + "img/android.41592a6a.jpg";